import app from '../dvaInstance'

export const resetReduxExceptUndoRedo = () => {
  // @ts-expect-error : Will update later
  const store = app._store

  const actions_except_undo_redo = [
    'actions/resetActions',
    'asrModels/resetASRModels',
    'asrProviders/resetASRProviders',
    'audioDemos/resetAudioDemos',
    'auditLogs/resetAuditLogs',
    'blocks/resetBlocks',
    'build/resetBuild',
    'calls/resetCalls',
    'comments/resetComments',
    'flows/resetFlows',
    'flowConfigs/resetFlowConfigs',
    'flowLayout/resetFlowLayout',
    'globalTriggers/resetGlobalTriggers',
    'integrations/resetIntegrations',
    'interactiveDemos/resetInteractiveDemos',
    'yamlValidator/resetYamlValidator',
    'languages/resetLanguages',
    'mis/resetMIS',
    'ontologies/resetOntologies',
    'ontologyLanguages/resetOntologyLanguages',
    'paths/resetPaths',
    'prompts/resetPrompts',
    'sluModels/resetSLUModels',
    'intents/resetSLUIntents',
    'entities/resetSLUEntities',
    'subFlows/resetSubFlows',
    'tags/resetTags',
    'ttsAgents/resetTTSAgents',
    'ttsProviders/resetTTSProviders',
    'utterances/resetUtterances',
    'utteranceContent/resetUtteranceContent',
    'tcnCampaigns/resetTCNCampaigns',
    'clients/resetClients',
    'providers/resetProviders',
    'sipLines/resetSIPLines',
    'virtualNumbers/resetVirtualNumbers',
    'workers/resetWorkers',
    'workerSIPLines/resetWorkerSIPLines',
    'campaignManager/resetCampaignManager',
  ]

  // Resetting whole redux state, apart from user (As user is being resetted everytime on login.)
  try {
    actions_except_undo_redo.forEach((action: string) => {
      store.dispatch({
        type: action,
      })
    })
  } catch (err: any) {
    throw new err()
  }
}

export const resetUndoRedo = () => {
  // @ts-expect-error : Will update later
  const store = app._store

  const actions_undo_redo = ['flowBuilder/clearUndoRedo', 'prompts/clearUndoRedo']

  // Resetting undo redo
  try {
    actions_undo_redo.forEach((action: string) => {
      store.dispatch({
        type: action,
      })
    })
  } catch (err: any) {
    throw new err()
  }
}
